import axios from 'axios';
import HttpHelper from '../helper/HttpHelper';

class AuthService {

    Login(payload) {
        return axios.post(HttpHelper.API_URL + '/auth/local', payload, HttpHelper.getHeader());
    }

    Register(payload) {
        return axios.post(HttpHelper.API_URL + '/auth/local/register', payload, HttpHelper.getHeader());
    }

    ForgotPassword(payload) {
        return axios.post(HttpHelper.API_URL + '/upload/sendmail', payload, HttpHelper.getHeader());
    }

}

export default new AuthService();